import Icons from '@shared/config/constants/Icons';
import React from 'react';
import cn from 'classnames';

import { isVariationV3Route } from '@shared/utils/general';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import styles from '../styles/FollowUs.module.css';

import { useAtomValue } from 'jotai';
import { dcbAtom } from '@shared/store/slice-atoms';
export const FollowUs = ({ tabIndex, followUsConfig = {} }) => {
  const anchorTabIndex = tabIndex === false ? undefined : tabIndex;
  const { t } = useTranslation();
  // @ts-ignore
  const { hide } = followUsConfig;
  // @ts-ignore
  const dcb = useAtomValue(dcbAtom);
  const isV3Route = isVariationV3Route(dcb.variationKey);

  if (hide) {
    return null;
  }

  return (
    <>
      <Row className={cn('mt-4', isV3Route && styles.rowMarginBottom)}>
        <Col>
          <p className={cn('section-title-1', 'fs-10', isV3Route && 'marg-t-22')}>
            {t('follow_us')}
          </p>
        </Col>
      </Row>

      <Row className="mt-1 mb-4">
        <Col>
          <div className="text-center">
            <a
              href="https://www.instagram.com/vuz/?hl=en"
              target="_blank"
              tabIndex={tabIndex}
              rel="noopener noreferrer"
            >
              <img
                alt="instagram icon"
                src={Icons.insta}
                className="img-fluid mx-3"
                width="26"
                height="25"
              />
            </a>
            <a
              href="https://www.facebook.com/360VUZ/?ref=py_c"
              target="_blank"
              tabIndex={anchorTabIndex}
              rel="noopener noreferrer"
            >
              <img
                alt="facebook icon"
                src={Icons.fb}
                className="img-fluid mx-3"
                width="13"
                height="25"
              />
            </a>
            <a
              href="https://twitter.com/360VUZ"
              target="_blank"
              tabIndex={anchorTabIndex}
              rel="noopener noreferrer"
            >
              <img
                alt="twitter icon"
                src={Icons.twitter}
                className="img-fluid mx-3"
                width="24"
                height="25"
              />
            </a>
          </div>
        </Col>
      </Row>
    </>
  );
};
